"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isResultsTableRowCellMainResultProperty = exports.resultsTableRowCellMainResultPropertyDefinition = void 0;
exports.resultsTableRowCellMainResultPropertyDefinition = {
    view: { label: 'Results Table Row Cell Main Result' },
    constraints: [
        {
            name: 'required',
            argument: true,
        },
        {
            name: 'oneOfProperties',
            argument: [
                'results-table-cell-value-asset',
                'results-table-cell-value-float',
                'results-table-cell-value-integer',
                'results-table-cell-value-percent',
                'results-table-cell-value-points',
                'results-table-cell-value-text',
                'results-table-cell-value-timestamp',
            ],
        },
    ],
    type: 'one-of-container',
    multiple: true,
    name: 'results-table-row-cell-main-result',
};
const isResultsTableRowCellMainResultProperty = (prop) => {
    return prop.name === exports.resultsTableRowCellMainResultPropertyDefinition.name;
};
exports.isResultsTableRowCellMainResultProperty = isResultsTableRowCellMainResultProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVzdWx0cy10YWJsZS1yb3ctY2VsbC1tYWluLXJlc3VsdC5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL3Jlc3VsdHMtdGFibGUtcm93LWNlbGwtbWFpbi1yZXN1bHQucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSwrQ0FBK0MsR0FBRztJQUM3RCxJQUFJLEVBQUUsRUFBRSxLQUFLLEVBQUUsb0NBQW9DLEVBQUU7SUFDckQsV0FBVyxFQUFFO1FBQ1g7WUFDRSxJQUFJLEVBQUUsVUFBVTtZQUNoQixRQUFRLEVBQUUsSUFBSTtTQUNmO1FBQ0Q7WUFDRSxJQUFJLEVBQUUsaUJBQWlCO1lBQ3ZCLFFBQVEsRUFBRTtnQkFDUixnQ0FBZ0M7Z0JBQ2hDLGdDQUFnQztnQkFDaEMsa0NBQWtDO2dCQUNsQyxrQ0FBa0M7Z0JBQ2xDLGlDQUFpQztnQkFDakMsK0JBQStCO2dCQUMvQixvQ0FBb0M7YUFDckM7U0FDRjtLQUNGO0lBQ0QsSUFBSSxFQUFFLGtCQUFrQjtJQUN4QixRQUFRLEVBQUUsSUFBSTtJQUNkLElBQUksRUFBRSxvQ0FBb0M7Q0FDWCxDQUFBO0FBSTFCLE1BQU0sdUNBQXVDLEdBQUcsQ0FBQyxJQUFrQixFQUFpRCxFQUFFO0lBQzNILE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyx1REFBK0MsQ0FBQyxJQUFJLENBQUE7QUFDM0UsQ0FBQyxDQUFBO0FBRlksUUFBQSx1Q0FBdUMsMkNBRW5EIn0=